// @ts-ignore
const ImageUrl = import.meta.env.VITE_API_IMAGE_URL

const davidMid = `${ImageUrl}/david-mid.jpg`;
const selmaImg = `${ImageUrl}/selma.jpg`;
const alexImg = `${ImageUrl}/alex-yazdani.jpg`;
const saraImg = `${ImageUrl}/sara-erikson.jpg`;
const juliaImg = `${ImageUrl}/juliah.jpg`;

export const reviews = [
    {
        id: 1,
        title: 'REVIEW_1_TITLE',
        readMore: 'REVIEW_1_READ_MORE',
        author: 'David Midhage',
        designation: 'REVIEW_1_DESIGNATION',
        avatar: davidMid,
        linkedInUrl: "https://www.linkedin.com/in/david-midhage-3769b883",
    },
    {
        id: 2,
        title: 'REVIEW_2_TITLE',
        readMore: 'REVIEW_2_READ_MORE',
        author: 'Selma Karamustafic',
        designation: 'REVIEW_2_DESIGNATION',
        avatar: selmaImg,
        linkedInUrl: 'https://www.linkedin.com/in/selma-karamustafic-477aa2104'
    },
    {
        id: 3,
        title: 'REVIEW_3_TITLE',
        readMore: 'REVIEW_3_READ_MORE',
        author: 'Alex Yazdani',
        designation: 'REVIEW_3_DESIGNATION',
        avatar: alexImg,
        linkedInUrl: 'https://www.linkedin.com/in/alex-yazdani-4193b1130'
    },
    // {
    //     id: 4,
    //     title: 'REVIEW_4_TITLE',
    //     readMore: 'REVIEW_4_READ_MORE',
    //     author: 'Sara Eriksson',
    //     designation: 'REVIEW_4_DESIGNATION',
    //     avatar: saraImg,
    //     linkedInUrl: 'https://www.linkedin.com/in/sara-eriksson-856050177'
    // },
    // {
    //     id: 5,
    //     title: 'REVIEW_5_TITLE',
    //     readMore: 'REVIEW_5_READ_MORE',
    //     author: 'Julia Hillding',
    //     designation: 'REVIEW_5_DESIGNATION',
    //     avatar: juliaImg,
    //     linkedInUrl: 'https://www.linkedin.com/in/juliahillding'
    // },
];